import React from 'react';
import { Route } from 'react-router-dom';
import AssessmentList from './components/AssessmentList';
import NewAssessment from './components/NewAssessment';
import AssessmentDetail from './components/AssessmentDetail';

/**
 * Document Assessment is a top-level module, not a project tab: the documents
 * being assessed were produced outside Athena, so requiring a project to exist
 * first would force the customer to set something up before getting any value.
 */
export const documentAssessmentRoutes = (
  <Route path="document-assessment">
    <Route index element={<AssessmentList />} />
    <Route path="new" element={<NewAssessment />} />
    <Route path=":assessmentId" element={<AssessmentDetail />} />
  </Route>
);
